import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"


import Seo from "../components/SEO"
import "../styles/new.css"
import "../styles/mobilenew.css"
import im1 from "../images/expph/exterior1.jpg"
const Portfolio = () => {


    return (
        <>
            <Seo
                title="Selected Projects"
                description="Showcase projects completed by nolan interiors."
                image={im1}
            />





            {/* <!--Portfolio header--> */}
            <div className="section">
                <h3 className="centerthis">SELECTED PROJECTS</h3>
            </div>


            {/* <!--Portfolio case study links-->
            <!--BEACH--> */}


            <div className="section portfolioflex">
                <Link to="/ocean-overlook" className="centerthis item0">
                    <article className="article">
                        <h3>OCEAN OVERLOOK</h3>
                        <p>Project Type : Residential</p>
                        <p>Area : 3000 Sq.ft</p>
                        <p>Location : West London</p>
                        <br />
                        <p><i>'A beautiful beachhouse at West London.'</i></p>
                    </article>
                </Link>

                <Link to="/ocean-overlook" className="item1"><StaticImage placeholder="dominantColor" className="image" src="../images/expph/beachhouseextra.jpg" alt="expph" /></Link>
                <Link to="/ocean-overlook" className="item2"><StaticImage placeholder="dominantColor" className="image" src="../images/bh/h1.jpg" alt="expph" /></Link>
                <Link to="/ocean-overlook" className="item3"><StaticImage placeholder="dominantColor" className="image" src="../images/bh/h4.jpg" alt="expph" /></Link>
                <Link to="/ocean-overlook" className="item4"><StaticImage placeholder="dominantColor" className="image" src="../images/bh/h6.jpg" alt="expph" /></Link>

            </div>




            <div className="section portfolioflex">
                <Link to="/white-villa" className="centerthis item0">
                    <article className="article">
                        <h3>WHITE VILLA</h3>
                        <p>Project Type : Residential</p>
                        <p>Area : 2800 Sq.ft</p>
                        <p>Location : Birmingham</p>
                        <br />
                        <p><i>'The White Villa is epitome of luxury and className.'</i></p>
                    </article>
                </Link>

                <Link to="/white-villa" className="item1">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/bh/wvex1.jpg" alt="expph" />
                </Link>
                <Link to="/white-villa" className="item2">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/wv/h3.jpg" alt="expph" />
                </Link>
                <Link to="/white-villa" className="item3">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/wv/h6.jpg" alt="expph" />
                </Link>
                <Link to="/white-villa" className="item4">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/wv/v4.jpg" alt="expph" />
                </Link>

            </div>


            <div className="section portfolioflex">
                <Link to="/wooden-castle" className="centerthis item0">
                    <article className="article">
                        <h3>WOODEN CASTLE</h3>
                        <p>Project Type : Residential</p>
                        <p>Area : 3450 Sq.ft</p>
                        <p>Location : Liverpool</p>
                        <br />
                        <p><i>'A Relaxing Wooden House for nature lovers.'</i></p>
                    </article>
                </Link>

                <Link to="/wooden-castle" className="item1">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/expph/exterior7wooden.jpg" alt="expph" />

                </Link>
                <Link to="/wooden-castle" className="item2">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/wd/h2.jpg" alt="expph" />

                </Link>
                <Link to="/wooden-castle" className="item3">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/wd/h5.jpg" alt="expph" />

                </Link>
                <Link to="/wooden-castle" className="item4">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/wd/h8.jpg" alt="expph" />

                </Link>

            </div>
            <div className="section portfolioflex">
                <Link to="/cafe-mania" className="centerthis item0">
                    <article className="article">
                        <h3>CAFE UMBER</h3>
                        <p>Project Type : Commercial</p>
                        <p>Area : 2800 Sq.ft</p>
                        <p>Location : Manchester</p>
                        <br />
                        <p><i>'Aesthetic coffe shop in Manchester city.'</i></p>
                    </article>
                </Link>

                <Link to="/cafe-mania" className="item1">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/expph/exteriorcafe.jpg" alt="expph" />
                </Link>
                <Link to="/cafe-mania" className="item2">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/caf/h1.jpg" alt="expph" />
                </Link>
                <Link to="/cafe-mania" className="item3">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/caf/h2.jpg" alt="expph" />
                </Link>
                <Link to="/cafe-mania" className="item4">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/caf/h4.jpg" alt="expph" />
                </Link>

            </div>


            <div className="section portfolioflex">
                <Link to="/cool-office" className="centerthis item0">
                    <article className="article">
                        <h3>COOL OFFICE</h3>
                        <p>Project Type : Commercial</p>
                        <p>Area : 3000 Sq.ft</p>
                        <p>Location : Oxford</p>
                        <br />
                        <p><i>'A cool office for fresh and innovative minds.'</i></p>
                    </article>
                </Link>

                <Link to="/cool-office" className="item1">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/expph/exterioroffice.jpg" alt="expph" />
                </Link>
                <Link to="/cool-office" className="item2">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/of/h2.jpg" alt="expph" />
                </Link>
                <Link to="/cool-office" className="item3">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/of/h3.jpg" alt="expph" />
                </Link>
                <Link to="/cool-office" className="item4">
                    <StaticImage placeholder="dominantColor" className="image" src="../images/of/h7.jpg" alt="expph" />
                </Link>

            </div>



            {/* 
            <!--Glorified Break tag--> */}

            {/* footer */}

            <div className="section flexthis">

                <div className="">
                    <StaticImage placeholder="dominantColor" className="image contact" src="../images/expph/portcta.jpg" alt="herolp" />
                </div>

                <div className="centerthis servicesmobile mobilemargins">
                    <article className="article">
                        <h3>I WOULD LOVE <br />TO TALK </h3>
                        <p>Want to talk with me about designing your home? Ah-mazing. I totally want to talk to YOU. Drop us a line!</p>
                        <h3><a href="mailto:hello@nolaninteriors.com">hello@nolaninteriors.com</a></h3>
                        <form action="">
                            <input type="text" placeholder="NAME" />
                            <input type="text" placeholder="EMAIL" />
                            <input type="text" placeholder="CONTACT NO." />
                            <input type="text" placeholder="REFERENCE" />
                            <textarea name="" id="" cols="30" rows="10" />
                            <button className="button">SUBMIT</button>
                        </form>

                        <div className="flexthis">
                            <a href="https://facebook.com/nolaninteriors" target="_blank" rel="noopener noreferrer"
                                className="button centerthis">facebook</a>
                            <a href="https://www.instagram.com/nolaninteriors" target="_blank" rel="noopener noreferrer"
                                className="button centerthis">instagram</a>
                            <a href="https://pinterest.com/nolaninteriors/" target="_blank" rel="noopener noreferrer"
                                className="button centerthis">pinterest</a>
                            <a href="https://www.houzz.com/nolaninteriors" target="_blank" rel="noopener noreferrer"
                                className="button centerthis">houzz</a>
                        </div>

                        <div className="flexthis">
                            <a href="https://asteriasoft.studio" target="_blank" rel="noopener noreferrer"
                                className="button centerthis">Website by Asteriasoft</a>
                        </div>
                    </article>

                </div>
            </div>



        </>

    )
}

export default Portfolio

